export function redirectToOldStudentPanel() {
    const currentUrl = window.location.href;
    const newUrl = currentUrl.replace('.panel.', '.');
    const url = new URL(newUrl);
    url.pathname = '/s/';

    // Hard redirect
    window.location.href = url.toString();
}

export function urlPath() {
    return window.location.protocol + '//' + window.location.host + window.location.pathname;

}

export function urlDomain() {
    return window.location.protocol + '//' + window.location.host;

}


export function objectToQueryString(obj) {
    const params = new URLSearchParams();

    for (const key in obj) {
        // Ensure the property belongs to the object itself, not its prototype chain
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];

            // Exclude properties with null or undefined values
            if (value !== null && typeof value !== 'undefined') {
                params.append(key, value);
            }
        }
    }

    return params.toString();
}